// extracted by mini-css-extract-plugin
export default {"container":"leftMenu_container__LU+S+","tabs":"leftMenu_tabs__BDRb5","tab":"leftMenu_tab__OueTW","selected":"leftMenu_selected__ijsHj"};